import styled from 'styled-components';
import BaseCircle from '../BaseCircle';
import { gradients } from '../../theme/helpers';

const Container = styled.div`
    align-items: center;
    text-align: center;
    width: 25rem;
    margin : auto;
`;

const MiddleButton = styled.a`
  background: ${gradients.gradientPrimary};
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 5rem;
  height: 2.5rem;
  padding: 0.5rem;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  p {
    color: white;
  }
`;

export { MiddleButton }

export default Container;
